module.exports = __webpack_public_path__ + "static/img/helene.ccbc228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dalslider/helene.png
// module id = hLIZ
// module chunks = 1